import { render, staticRenderFns } from "./UserButtonView.vue?vue&type=template&id=02356807"
import script from "./UserButtonView.vue?vue&type=script&lang=js"
export * from "./UserButtonView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports